/**
 * 桌面 2×2 PDP：右上变体格与 variant-picker 再同步
 * 主题内联脚本在 on:variant:change 时若选中态尚未写入 DOM，会仍用旧 variant 图。
 * 适用于用 Shopify 变体主图填充右上格的产品（喷泉、拾便袋分配器等）。
 * 不包含：EasyGo Carrier/Outdoor、MuseStand、Arena 等由专用脚本写 CDN 合成图的产品。
 */
(function () {
  'use strict';

  let updateTimer = null;

  function isCustomizePage() {
    return document.querySelector('.custom-builder') !== null;
  }

  function isDesktopPdpWith2x2() {
    const main = document.querySelector('.main-image');
    if (!main || !main.querySelector('.product-media-2x2')) return false;
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function hasVariant2x2Cell() {
    return !!document.querySelector('.main-image .product-media-2x2 .media-2x2-cell--variant');
  }

  /** 专用脚本会自行写右上格 CDN 图，避免本脚本覆盖 */
  function isCdnCompositePdp() {
    const path = window.location.pathname.toLowerCase();
    const title = (document.querySelector('.product-title') && document.querySelector('.product-title').textContent
      ? document.querySelector('.product-title').textContent
      : ''
    ).toLowerCase();
    const blob = path + ' ' + title;

    if (/valentine|情人节/.test(blob)) return true;

    if (path.includes('pet-travel-gift-set')) return true;
    if (title.includes('outdoor set') || title.includes('travel gift set')) return true;
    if (title.includes('accogift') && (title.includes('easygo') || title.includes('outdoor'))) return true;

    if (
      path.includes('easygo-pet-carrier') ||
      path.includes('custom-pet-carrier') ||
      path.includes('customizable-pet-carrier')
    ) {
      return true;
    }
    if (title.includes('easygo pet carrier') && !/detachable|handle pair/i.test(title)) return true;

    if (
      title.includes('musestand') ||
      title.includes('dual-color-bowl') ||
      (title.includes('feeding set') && title.includes('bowl')) ||
      (title.includes('ceramic dog bowl') && title.includes('feeding mat'))
    ) {
      return true;
    }
    if (
      path.includes('musestand') ||
      path.includes('dual-color-bowl') ||
      path.includes('accogift-feeding') ||
      path.includes('feeding-set')
    ) {
      return true;
    }

    if (title.includes('arena pet bowl') || title.includes('arena elevated') || /roman.column|roman-column/.test(blob)) {
      return true;
    }

    // EasyGo Carrier Detachable Handle Pair：各颜色为独立 variant 主图，需本脚本同步 2×2 右上格（非 CDN 合成）

    return false;
  }

  function shouldAttachListeners() {
    if (isCustomizePage()) return false;
    if (isCdnCompositePdp()) return false;
    return hasVariant2x2Cell();
  }

  function shouldRunSync() {
    return shouldAttachListeners() && isDesktopPdpWith2x2();
  }

  function getVariantPicker() {
    return document.querySelector('.js-product variant-picker');
  }

  function normalizeOptionValue(s) {
    if (s == null || s === '') return s;
    return String(s)
      .replace(/[⬆️⬇️↑↓🔺🔻]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function findVariantForSelectedOptions(variants, selectedOptions) {
    if (!variants || !selectedOptions || selectedOptions.some(function (o) {
      return o == null || o === '';
    })) {
      return null;
    }
    return variants.find(function (v) {
      return v.options.every(function (val, idx) {
        return normalizeOptionValue(val) === normalizeOptionValue(selectedOptions[idx]);
      });
    });
  }

  function getVariantMediaMapFromTheme() {
    const el = document.querySelector('script[type="application/json"][id^="variant-2x2-data-"]');
    if (!el) return {};
    try {
      const d = JSON.parse(el.textContent);
      return d.variantMedia || {};
    } catch (e) {
      return {};
    }
  }

  function resolveVariantImageUrl(variant) {
    if (!variant) return null;
    // 主题 / Liquid JSON 最常见：featured_media.preview_image.src（main.js setActiveMedia 也用 featured_media.id）
    if (variant.featured_media) {
      const fm = variant.featured_media;
      if (fm.preview_image && fm.preview_image.src) return fm.preview_image.src;
      if (typeof fm === 'object' && fm.src) return fm.src;
    }
    if (variant.featured_image) {
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant.featured_image.src) return variant.featured_image.src;
    }
    if (variant.image && variant.image.src) return variant.image.src;
    const map = getVariantMediaMapFromTheme();
    const fromMap = map[String(variant.id)] || map[String(Number(variant.id))];
    if (fromMap) return fromMap;
    return null;
  }

  function setDesktop2x2VariantCellImage(imageUrl) {
    if (!imageUrl) return;
    const cell = document.querySelector('.product-media-2x2 .media-2x2-cell--variant');
    let img = cell && cell.querySelector('img');
    if (cell && !img) {
      img = document.createElement('img');
      img.alt = '';
      cell.appendChild(img);
    }
    if (!img) return;

    const test = new Image();
    test.onload = function () {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.loading = 'eager';
      img.src = imageUrl;
      console.log('✅ [Pdp2x2VariantSync] 右上格已同步 variant 主图');
    };
    test.onerror = function () {
      console.warn('⚠️ [Pdp2x2VariantSync] 变体主图加载失败:', imageUrl);
    };
    test.src = imageUrl;
  }

  function findVariantByFormId(picker) {
    const input = document.querySelector('.js-product .js-product-form input[name="id"], .js-product-form input[name="id"]');
    if (!input || !input.value || !picker || !picker.data || !picker.data.variants) return null;
    const vid = String(input.value).trim();
    return picker.data.variants.find(function (v) {
      return String(v.id) === vid;
    });
  }

  function syncVariantCellFromPicker() {
    if (!shouldRunSync()) return;

    const picker = getVariantPicker();
    if (!picker || typeof picker.getSelectedOptions !== 'function' || typeof picker.getSelectedVariant !== 'function') {
      return;
    }

    picker.selectedOptions = picker.getSelectedOptions();
    let variant = picker.getSelectedVariant();
    if (!variant && picker.data && picker.data.variants) {
      variant = findVariantForSelectedOptions(picker.data.variants, picker.selectedOptions);
    }
    if (!variant && picker.data && picker.data.variants) {
      variant = findVariantByFormId(picker);
    }
    const url = resolveVariantImageUrl(variant);

    if (url) {
      setDesktop2x2VariantCellImage(url);
    } else if (variant) {
      console.warn('⚠️ [Pdp2x2VariantSync] 当前变体无可用主图 URL:', variant.id, variant.title, variant);
    } else {
      console.warn('⚠️ [Pdp2x2VariantSync] 无法匹配变体，选项:', picker.selectedOptions);
    }
  }

  /** 变体事件里 detail.variant 已是最新，先于 DOM 的 getSelectedOptions */
  function syncFromEventVariant(variant) {
    if (!shouldRunSync() || !variant) return;
    const url = resolveVariantImageUrl(variant);
    if (url) setDesktop2x2VariantCellImage(url);
  }

  function scheduleSync() {
    if (!shouldAttachListeners()) return;
    if (updateTimer) clearTimeout(updateTimer);
    requestAnimationFrame(function () {
      syncVariantCellFromPicker();
    });
    updateTimer = setTimeout(function () {
      requestAnimationFrame(function () {
        syncVariantCellFromPicker();
        setTimeout(syncVariantCellFromPicker, 60);
        setTimeout(syncVariantCellFromPicker, 160);
        setTimeout(syncVariantCellFromPicker, 320);
      });
    }, 120);
  }

  function init() {
    if (!shouldAttachListeners()) return;

    if (!document.body.dataset.pdp2x2VariantSyncBound) {
      document.body.dataset.pdp2x2VariantSyncBound = 'true';

      document.body.addEventListener(
        'click',
        function (e) {
          if (!shouldAttachListeners()) return;
          const t = e.target;
          if (!t || !t.closest) return;
          if (
            t.closest('.color-swatch') ||
            t.closest('.text-option') ||
            t.closest('.custom-select__option') ||
            t.closest('.opt-label') ||
            t.closest('.option-selector__btns') ||
            (t.matches && t.matches('input[type="radio"]')) ||
            (t.matches && t.matches('input.js-option')) ||
            (t.matches && t.matches('label[for*="option"]'))
          ) {
            scheduleSync();
          }
        },
        true
      );

      document.body.addEventListener(
        'change',
        function (e) {
          if (!shouldAttachListeners()) return;
          const t = e.target;
          const tag = t && t.tagName ? t.tagName.toLowerCase() : '';
          const insideCustomSelect = t && t.closest && t.closest('custom-select');
          if (
            (t.matches && t.matches('select')) ||
            (t.matches && t.matches('input[type="radio"]')) ||
            tag === 'custom-select' ||
            insideCustomSelect
          ) {
            scheduleSync();
          }
        },
        true
      );

      const section = document.querySelector('.js-product');
      if (section) {
        section.addEventListener('on:variant:change', function (e) {
          if (!shouldAttachListeners()) return;
          const v = e.detail && e.detail.variant;
          syncFromEventVariant(v);
          scheduleSync();
        });
      }

      document.addEventListener(
        'change',
        function (e) {
          if (!shouldAttachListeners() || !shouldRunSync()) return;
          const t = e.target;
          if (t && t.matches && t.matches('input[name="id"]') && t.closest && t.closest('.js-product-form')) {
            scheduleSync();
          }
        },
        true
      );
    }

    setTimeout(scheduleSync, 400);
    setTimeout(scheduleSync, 1200);
  }

  window.Pdp2x2VariantSync = {
    sync: syncVariantCellFromPicker,
    syncFromVariant: syncFromEventVariant,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 300);
    });
  } else {
    setTimeout(init, 300);
  }
})();
